// extracted by mini-css-extract-plugin
module.exports = {"Container":"MilkButton_Container__1T1c_","Button":"MilkButton_Button__1uazH","loader":"MilkButton_loader__1b8fa","load5":"MilkButton_load5__tDnoD"};